import { TOGGLE_INTERACTIVE_BOX } from "./displayInteractiveBoxReducer"

export const toggleInteractiveBox = (obj) => ({
    type: TOGGLE_INTERACTIVE_BOX,
    payload: obj
})